import AutomatedEmailForm from '@/pages/events/messaging/email_blasts/components/AutomatedEmailForm'
import type {
  AutomatedEmail,
  Event,
} from '@/pages/events/messaging/email_blasts/types'
import type { MergeTagOptions } from '@/lib/mergeTags'

export interface CertificateEmailTabProps {
  event: Event
  automatedEmail: AutomatedEmail
  mergeTagOptions?: MergeTagOptions
  /**
   * Where Cancel goes. Supplied by the page rather than defaulted here so it is
   * literally the same function as the page header's back arrow — the two are a
   * single destination and drift between them is the classic way a Cancel button
   * ends up somewhere its own back button does not.
   */
  onCancel: () => void
}

/**
 * The Email Content half of the e-certificate builder.
 *
 * The certificate design and the email that carries it are two halves of one
 * AutomatedEmailTemplate, so this tab hosts the very same form the standalone
 * automated email page uses rather than a copy of it. Two props adapt it to
 * living in a tab:
 *
 * - `returnTo="certificates"` rides along with the PATCH as a query parameter.
 *   The server matches it against its own allowlist and builds the redirect
 *   itself, landing back on this tab instead of the Email Blast index.
 * - `renderActions="inline"` keeps the action bar in the document flow.
 *   The default `fixed` bar is pinned to the viewport with a hardcoded sidebar
 *   offset, which only lines up when the form is the entire page; inside a tab
 *   it would float over the content and ignore the tab strip.
 */
export default function CertificateEmailTab({
  event,
  automatedEmail,
  mergeTagOptions,
  onCancel,
}: CertificateEmailTabProps) {
  return (
    <AutomatedEmailForm
      event={event}
      automatedEmail={automatedEmail}
      mergeTagOptions={mergeTagOptions}
      returnTo="certificates"
      renderActions="inline"
      onCancel={onCancel}
    />
  )
}
